import Avatar from '@mui/material/Avatar';
import { useTheme } from '@mui/material/styles';
import PropTypes from 'prop-types';
import React from 'react';

import CallSplitIcon from '@mui/icons-material/CallSplitRounded';
import GrassIcon from '@mui/icons-material/Grass';
import HomeWorkIcon from '@mui/icons-material/HomeWork';
import PersonRoundedIcon from '@mui/icons-material/PersonRounded';
import WorkIcon from '@mui/icons-material/Work';
import Box from '@mui/material/Box';

export const UsageIcons = {
  BUSINESS: WorkIcon,
  BUSINESS_S_CORP: WorkIcon,
  FARMING: GrassIcon,
  PARTNERSHIP: WorkIcon,
  PERSONAL: PersonRoundedIcon,
  RENTAL_PROPERTY: HomeWorkIcon,
  SPLIT: CallSplitIcon,
};

const NOT_SPECIFIED_ICON = PersonRoundedIcon;

function UsageAndEntityIcon(props) {
  const { color, sx = {}, size, usageIcon, ...other } = props;
  const theme = useTheme();
  let width;
  let svgWidth;
  let height;
  let svgHeight;
  let fontSize;
  switch (size) {
    case 'xsmall':
      width = 20;
      height = 20;
      fontSize = '1rem';
      svgWidth = '0.8em';
      svgHeight = '0.8em';
      break;
    case 'small':
      width = 24;
      height = 24;
      fontSize = '1.25rem';
      svgWidth = '0.8em';
      svgHeight = '0.8em';
      break;
    case 'large':
      width = 56;
      height = 56;
      fontSize = '1rem';
      svgWidth = '2em';
      svgHeight = '2em';
      break;
    case 'medium':
    default:
      width = 40;
      height = 40;
      fontSize = '1rem';
      svgWidth = '2em';
      svgHeight = '2em';
      break;
  }

  const Icon = UsageIcons[usageIcon] || NOT_SPECIFIED_ICON;
  if (usageIcon === 'SPLIT') {
    return (
      <Box sx={{ width, height, color: theme.palette.icon.main, alignSelf: 'center', ...sx }}>
        <Icon sx={{ fontSize, height, width }} />
      </Box>
    );
  }
  return (
    <Avatar
      sx={{
        width,
        height,
        color: theme.palette.background.paper,
        alignSelf: 'center',
        backgroundColor: theme.palette[color]?.main || theme.palette.background.layer2,
        ...sx,
      }}
      {...other}
    >
      <Icon sx={{ fontSize, height: svgHeight, width: svgWidth }} />
    </Avatar>
  );
}

export default UsageAndEntityIcon;

UsageAndEntityIcon.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOf(['xsmall', 'small', 'medium', 'large']),
  usageIcon: PropTypes.string,
  sx: PropTypes.object,
};
